import Header from "./header/Header";
import Footer from "./footer/Footer";
import NavLinks from "./header/NavLinks";
const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {/* <NavLinks /> */}
      {children}
      <Footer />
    </>
  );
};

export default Layout;
